export default mode => (dispatch) => {
  dispatch({ type: `APP/PREVIEW/${mode === 'light' ? 'LIGHT' : 'DARK'}` });
};
